import React from 'react';
import { Typography } from '@mui/material';
import ContainerBox from 'components/ContainerBox';
import { useTranslation } from 'services/localization';

const Oskar = () => {
	const { t } = useTranslation();
	return (
		<ContainerBox>
			<Typography variant="h6" gutterBottom>
				{'Oskar'}
			</Typography>
			<Typography>{t('oskar.oskarPosIntegrationInUse', 'Oskar POS integration in use')}</Typography>
		</ContainerBox>
	);
};

export default Oskar;
